import { render, staticRenderFns } from "./index.vue?vue&type=template&id=106c86ed&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=106c86ed&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c86ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106c86ed')) {
      api.createRecord('106c86ed', component.options)
    } else {
      api.reload('106c86ed', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=106c86ed&scoped=true", function () {
      api.rerender('106c86ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/index.vue"
export default component.exports